import { useState } from 'react'

import Paper from '@mui/material/Paper'

import StyledTable from '@components/StyledTable'

import { useWerkbakken } from '../../aansluiting/dashboard/hooks/useWerkbakken'
import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { useAutosuggest } from '../../autosuggest/hooks/useAutosuggest'
import { ENTITIES } from '../../entity'
import { Page } from '../../theme/components/Page'
import { PageSection } from '../../theme/components/PageSection'
import { useDeelnemerValuelists } from '../../valuelists/hooks/useDeelnemerValuelists'
import { OpdrachtenFilters } from '../components/OpdrachtenFilters'
import { OpdrachtenTableRow } from '../components/OpdrachtenTableRow'
import { useOpdrachtenSearch } from '../hooks/useOpdrachtenSearch'

const headerCells = [
  { id: 'opdrachtId', numeric: true, label: 'Opdracht id', sort: false },
  { id: 'clusterId', numeric: false, label: 'Cluster id', sort: false },
  { id: 'versieNummer', label: 'Versienummer', sort: false, fixed: 50 },
  { id: 'discipline', label: 'Discipline', sort: false, fixed: 50 },
  { id: 'adres', numeric: false, label: 'Adres', sort: false },
  { id: 'netbeheerder', numeric: true, label: 'Netbeheerder', sort: false },
  { id: 'aannemer', numeric: true, label: 'Aannemer', sort: false },
  {
    id: 'details.creatieDatum',
    numeric: false,
    label: 'Creatiedatum',
    sort: true,
  },
  { id: 'changed', numeric: false, label: 'Mutatiedatum', sort: true },
  { id: 'status', label: 'Status', sort: false },
  { id: 'details', label: 'Details', sort: false, fixed: 100 },
] as const

export const Opdrachten = () => {
  const { data: deelnemerValuelists } = useDeelnemerValuelists()
  const {
    data: { items: opdrachten, count, skip, limit },
    isLoading,
    isError,
    initialFilters,
    onChangeFilters,
    onChangeSort,
    onChangePage,
    filters,
    sort,
    onReset,
    onRefresh,
  } = useOpdrachtenSearch()
  const { data: werkbakken } = useWerkbakken()
  const [searchText, setSearchText] = useState('')
  const { data: options } = useAutosuggest({
    text: searchText,
    entityType: ENTITIES.DEELNEMER_OPDRACHT,
  })

  const { canViewProjecten } = useAuthenticatedUser()

  return (
    <Page
      title={['Opdrachten', 'Aansluiting']}
      fillScreen
      breadcrumbs={[
        { label: 'Aansluiting', href: '/home', tooltip: 'CAPO home' },
        { label: 'Opdrachten' },
      ]}
    >
      <PageSection
        id="opdrachten"
        heading="Overzicht van alle opdrachten als deelnemer"
      />

      <Paper>
        <div>
          <OpdrachtenFilters
            onChange={onChangeFilters}
            filters={filters}
            initialFilters={initialFilters}
            onSearchChange={(search: string) => setSearchText(search)}
            options={options}
            onRefresh={onRefresh}
            onReset={onReset}
            werkbakken={werkbakken}
            filterOptions={deelnemerValuelists}
          />

          <StyledTable
            onChangeSort={onChangeSort}
            onChangePage={onChangePage}
            headerCells={headerCells}
            sort={sort}
            stats={{ count, skip, limit }}
            loading={isLoading}
            isError={isError}
          >
            {opdrachten.map((opdracht) => (
              <OpdrachtenTableRow
                key={opdracht.opdrachtId}
                opdracht={opdracht}
                canNavigateToProject={
                  /* v8 ignore next - TODO: missing coverage -- @preserve */
                  canViewProjecten &&
                  /* v8 ignore next - TODO: missing coverage -- @preserve */
                  opdracht.details?.combi &&
                  /* v8 ignore next - TODO: missing coverage -- @preserve */
                  opdracht.details.combi.combi !== 'GEEN'
                }
              />
            ))}
          </StyledTable>
        </div>
      </Paper>
    </Page>
  )
}
